/**
 * Static disclaimer shown at the top of the Plan page. Everything below
 * it is a forecast — a prediction blending pipeline, history, and manual
 * judgement — not a confirmed result. The page is built for sales reps
 * and managers who already know this; the banner exists for anyone
 * outside sales who lands here and could otherwise mistake a forecast
 * figure for an actual one.
 */
import { Info } from "lucide-react";

export function ForecastDisclaimerBanner() {
  return (
    <div
      className="rounded-lg border border-border bg-muted p-3 flex items-start gap-2"
      role="status"
    >
      <Info className="size-4 mt-0.5 shrink-0 text-muted-foreground" />
      <p className="text-sm text-muted-foreground">
        <span className="font-medium text-foreground">
          This page shows forecasts, not confirmed results.
        </span>{" "}
        Every figure below is a prediction of future sales — blending pipeline,
        past patterns, and reps&apos; own judgement — and can change as the
        picture develops.
      </p>
    </div>
  );
}
